import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import ls from './ls';
import api from './api';

import { AUTH_STORAGE_NAME, AUTH_COOKIES } from './consts';

// import cart from './store/modules/cart';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // cart,
  },
  state: {
    auth: {},
    layout: 'layout-default',
    eventData: {},
    sections: [],
    friends: [],
    countries: [],
  },
  mutations: {
    setEventData(state, data) {
      Vue.set(state, 'eventData', data);
    },
    setSections(state, data) {
      Vue.set(state, 'sections', data);
    },
    login(state, data) {
      Vue.set(state, 'auth', data);
      api.token = data.token;
      api.userAuth = data.user;
      axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      ls.deleteCookies(AUTH_COOKIES);
      ls.setItem(AUTH_STORAGE_NAME, JSON.stringify(data));
      ls.setCookies(AUTH_COOKIES, JSON.stringify(data));
      ls.setCookies('verifySession', true);
    },
    logout(state) {
      Vue.set(state, 'auth', {});
    },
    setLayout(state, newLayout) {
      state.layout = newLayout;
    },
    setFriends(state, payload) {
      Vue.set(state, 'friends', payload);
    },
    setCountries(state, payload) {
      Vue.set(state, 'countries', payload);
    },
  },
  actions: {
    login({ commit }, data) {
      const { payload, captcha } = data;
      const headers = {
        captcha
      }
      return new Promise(async (resolve, reject) => {
        try {
          const res = await api.login(payload, headers);
          if (res.status && !res.isOTPRequired) {
            commit('login', res);
          }
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        api.token = null;
        api.userAuth = null;
        delete axios.defaults.headers.common.Authorization;
        ls.removeItem(AUTH_STORAGE_NAME);
        ls.deleteCookies(AUTH_COOKIES);
        resolve();
      });
    },
    checkFriend({ commit }, data) {
      commit('friends', data)
    },
    addFriend({ commit, state }, data) {
      const { friends } = state;
      friends.push(data)
      commit('friends', friends)
    },
  },
  getters: {
    getFriends(state) {
      return state.friends;
    }
  }
});
